import mime from "mime/lite";

export function dataURIToBlob(dataURI: string): Blob {
	// convert base64 to raw binary data held in a string
	// doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
	const byteString = atob(dataURI.split(",")[1]);

	// separate out the mime component
	const mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

	// write the bytes of the string to an ArrayBuffer
	const ab = new ArrayBuffer(byteString.length);

	// create a view into the buffer
	const ia = new Uint8Array(ab);

	// set the bytes of the buffer to the correct values
	for (let i = 0; i < byteString.length; i++) {
		ia[i] = byteString.charCodeAt(i);
	}

	// write the ArrayBuffer to a blob, and you're done
	const blob = new Blob([ab], { type: mimeString });
	return blob;
}

function blobToFile(blob: Blob, fileName: string): File {
	return new File([blob], fileName, { type: blob.type });
}

export function dataURIToFile(dataURI: string, fileName: string): File {
	const blob = dataURIToBlob(dataURI);
	const extension = mime.getExtension(blob.type) ?? "";
	if (fileName.indexOf(extension) === -1) {
		fileName += `.${extension}`;
	}
	return blobToFile(blob, fileName);
}

export function dataURIorBlobToFile(dataURI: string | Blob, fileName: string): File {
	if (dataURI instanceof Blob) {
		return blobToFile(dataURI, fileName);
	}
	return dataURIToFile(dataURI, fileName);
}

export function blobToBase64(blob: Blob): Promise<string> {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => {
			const dataUrl = reader.result;
			resolve(dataUrl as string);
		};
		reader.onerror = error => {
			reject(error);
		};
		reader.readAsDataURL(blob);
	});
}

export function isDataURL(s: string): boolean {
	return Boolean(s?.startsWith("data:"));
}

export function downloadBlob(filename: string, blob: string): void {
	const a = document.createElement("a");
	a.href = blob;
	a.download = filename;
	a.style.display = "none";
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
}

// Downloads a same origin URL without navigating
export function downloadUrl(url: string): void {
	const a = document.createElement("a");
	a.href = url;
	a.download = "";
	a.style.display = "none";
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
}

export function downloadText(filename: string, blob: string): void {
	const element = document.createElement("a");
	const file = new Blob([blob], { type: "text/plain" });
	element.href = URL.createObjectURL(file);
	element.download = filename;
	document.body.appendChild(element);
	element.click();
	document.body.removeChild(element);
}
